import { createFileRoute } from "@tanstack/react-router";
import { LobbyPage } from "@/features/game-resources";
import { loadLobby } from "@/features/game-resources/records";
import {
  resourceHead,
  resourceSearchSchema,
} from "@/features/game-resources/navigation";

export const Route = createFileRoute("/_site/$coworld_/lobbies/$lobbyId")({
  validateSearch: (search) => resourceSearchSchema.parse(search),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ params, deps, abortController }) =>
    loadLobby({
      data: {
        resourceId: params.lobbyId,
        game: { slug: params.coworld, catalog_status: "listed" },
        search: deps.search,
      },
      signal: abortController.signal,
    }),
  head: () => resourceHead("Lobby"),
  component: Page,
});

function Page() {
  return <LobbyPage data={Route.useLoaderData()} />;
}
